import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NoticeTooltipOnHover from '../../../_utils/notice-tooltip';
import PhotoLowResolutionIcon from './photo-low-resolution-icon';
import { POOR_RESOLUTION_MESSAGE } from './constants';

// Displays a low-resolution warning for when the original, uncropped photo is low DPI, with a tooltip.
const RawPhotoLowResolutionBadge = ({ tooltipPosition, tooltipCSSClasses, id }) => (
  <NoticeTooltipOnHover
    tooltipCSSClasses={classNames(
      'dpi-tooltip',
      'dpi-tooltip-below-minimum',
      tooltipCSSClasses,
    )}
    tooltipPosition={tooltipPosition}
    content={POOR_RESOLUTION_MESSAGE}
    show={false}>
    <div className="dpi-notice__container" tabIndex="0">
      <PhotoLowResolutionIcon
        id={id}
        className="dpi-notice-raw-image-low-dpi dpi-notice-below-minimum"
        aria-label={POOR_RESOLUTION_MESSAGE}
      />
    </div>
  </NoticeTooltipOnHover>
);

RawPhotoLowResolutionBadge.propTypes = {
  tooltipPosition: PropTypes.string,
  tooltipCSSClasses: PropTypes.string,
  id: PropTypes.string,
};

RawPhotoLowResolutionBadge.defaultProps = {
  tooltipPosition: undefined,
  tooltipCSSClasses: undefined,
  id: undefined,
};

export default RawPhotoLowResolutionBadge;
